export class User {
    username: string;
    sessionId: string;
    token: string;
    expire_time: number;
    refresh_token: string;
    refresh_token_expires: number;
    name: string;
    title: string;
    other_email: string;
    mobile: string;
    signature: string;
    translate: string;
    image: string;
    uuid: string;
    usedQuota: number;
    totalQuota: number;
    other_email_validated: number;
    push_notification_id: string;
}

export class UserLoginInfo {
    email: string;
    password: string;
    captcha_id: string;
    captcha_answer: string;
    reactivate: number;
    details: 1;
}

export class UserAccountInfo {
    name: string;
    title: string;
    access_token: string;
    active_sync: string;
    archieve: string;
    bulkmail: string;
    client_id: string;
    device_id: string;
    expire_time: number;
    image: '';
    mobile: string;
    push_notification_id: string;
    two_fa_code: string;
    id: number;
    mfa: number;
    total_quota: number;
    two_fa_security: number;
    two_fa_time_out: number;
    used_quota: number;
    change_password: boolean;
    username: string;
    refresh_token_info: RefreshTokenInfo;
}


class RefreshTokenInfo {
    id: number;
    refresh_token: string;
    expire_time: number;
}
